export default "__VITE_ASSET__BkkmMngA__"